module.exports = __webpack_public_path__ + "img/Side-loader-Icon.88d364e.png";